import { createEventDispatcher } from 'svelte';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function debounce<T extends (...args: any[]) => any>(func: T, wait: number): T {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  return ((...args: Parameters<T>): ReturnType<T> => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => func(...args), wait);
    return timeoutId as ReturnType<T>;
  }) as T;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type EventDispatcher<T = any> = (type: string, detail?: T) => void;

type CreateEventDispatcherDebounced = <T>(wait: number) => EventDispatcher<T>;

export const createEventDispatcherDebounced: CreateEventDispatcherDebounced = (wait) => {
  const dispatch = createEventDispatcher();
  return debounce(dispatch, wait);
};